import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { alertActions, user_profileActions } from 'actions';
import { statisticsErrorMessage } from '../statisticsError';
import { EMPTY_BUCKETS } from './constants';

// Time-series buckets for the range, refetched whenever the range or the exclusions change.
export function useTimeSeries(userId, range, excludedWorkspaceIds, excludedOrganizationIds) {
  const dispatch = useDispatch();
  const [buckets, setBuckets] = useState(EMPTY_BUCKETS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    setLoading(true);

    user_profileActions
      .fetchProductivityTimeSeries(userId, range, excludedWorkspaceIds, excludedOrganizationIds)
      .then((data) => {
        if (isMounted && data?.status === 'ok') setBuckets(data.buckets || EMPTY_BUCKETS);
      })
      // Without this a rejected range (400) or a throttle (429) falls through to the
      // "no time tracked in this range" empty state, which is the wrong explanation.
      .catch((error) => {
        if (!isMounted) return;

        setBuckets(EMPTY_BUCKETS);
        dispatch(alertActions.error(statisticsErrorMessage(error)));
      })
      .finally(() => {
        if (isMounted) setLoading(false);
      });

    return () => {
      isMounted = false;
    };
    // The id arrays are tracked by their joined keys.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId, range, excludedWorkspaceIds.join(','), excludedOrganizationIds.join(',')]);

  return { buckets, loading };
}

export default useTimeSeries;
